import i18n from './index';
import { normalizeToSupportedLanguage, setStoredLanguage } from './language';

export type ProfileLanguageLike = string | null | undefined;

/**
 * Future hook: call this after fetching the admin user profile.
 * Keeps language normalization and persistence in one place.
 */
export const applyProfileLanguage = (lang: ProfileLanguageLike) => {
  const normalized = normalizeToSupportedLanguage(lang);

  if (!normalized) return;

  setStoredLanguage(normalized);
  i18n.changeLanguage(normalized);
};

